<template>
    <div>
        <breadcrumbs class="mb-3" />
        <page-title :text="$t('page_titles.registration_page_title')" />
        <div class="mb-4 d-flex align-center flex-wrap">
            <v-btn data-cy="create" variant="flat" to="/registration-requests/new" class="bg-primary me-2 mb-2">
                {{ $t('new_lead') }}
            </v-btn>
            <v-btn
                class="me-2 mb-2"
                variant="outlined"
                color="primary"
                :disabled="!selected.length"
                data-cy="show-edit-companies-modal"
                @click="editModal = true"
            >
                {{ $t('mass_edit') }}
            </v-btn>
            <v-btn
                v-if="authStore.isTO1"
                data-cy="send-email"
                variant="outlined"
                color="primary"
                class="me-2 mb-2"
                :disabled="!emails.length"
                @click="emailModal = true"
            >
                {{ $t('send_email') }}
            </v-btn>
            <v-btn
                color="primary"
                variant="text"
                data-cy="file-excel"
                icon="mdi-file-excel"
                @click="$toast.warning($t('contact_support_to_activate'))"
            />
            <v-btn
                color="primary"
                variant="text"
                icon="mdi-upload-box"
                @click="$toast.warning($t('contact_support_to_activate'))"
            />
        </div>
        <RegistrationRequests ref="registrationRequests" v-model="selected" />
        <SendClientsEmailModal v-model="emailModal" :emails="emails" @sent="selected = []" />
        <ModalWrapper v-model="editModal">
            <template v-slot:title>
                {{ $t('mass_edit') }}
            </template>
            <template v-slot:content>
                <v-list density="compact">
                    <v-list-item v-for="(item, index) in selected" :key="index" class="px-0">
                        {{ item.name }}
                    </v-list-item>
                </v-list>
            </template>
            <template v-slot:btns>
                <v-btn variant="flat" @click="deleteSelected">{{ $t('activate') }}</v-btn>
                <v-btn color="error" variant="flat" @click="activateSelected">{{ $t('delete') }}</v-btn>
            </template>
        </ModalWrapper>
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import RegistrationRequests from '~/components/account/registrationRequests/RegistrationRequests.vue'
    import PageTitle from '~/components/parts/PageTitle.vue'
    import SendClientsEmailModal from '~/components/account/modals/SendClientsEmailModal.vue'

    const emailModal = ref(false)
    const emails = computed(() => selected.value.map(({companyInfoMessage}) => companyInfoMessage.emails).flat())

    const editModal = ref(false)
    const selected = ref([])

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()
    const registrationRequests = ref()

    async function requestsInBatches(rqs, batchSize) {
        const results = []
        for (let i = 0; i < rqs.length; i += batchSize) {
            const batch = rqs.slice(i, i + batchSize)
            const batchResults = await Promise.allSettled(batch)
            results.push(...batchResults)
        }
        const successResults = results.filter(({status}) => status === 'fulfilled')
        if (results.length === successResults.length) {
            $toast.success(t('success_message.all_requests_processed_successfully'))
        } else {
            $toast.warning(
                `${t('warning_message.requests_is_not_processed')}: ${results.length - successResults.length}`
            )
        }
        editModal.value = false
        registrationRequests.value.loadData()
    }

    const deleteSelected = () => {
        requestsInBatches(
            selected.value.map(({id}) => $api.companyRegistrationRequestDelete.post(id)),
            5
        )
    }

    const activateSelected = () => {
        requestsInBatches(
            selected.value.map(({id}) => $api.companyRegistrationRequestActivate.post(id)),
            5
        )
    }
</script>
